import DhtmlTitle from "../dhtml_title"
import {DateFormat} from "../date_format"
import messageResource from "../messageResource"
import UserTime from "../user_time"
import {getObjectHeight, getBodyScrollTop, getBodyScrollLeft, getInsideWindowHeight, getEventObj} from "../atBrowserUtils"
import {escapeHtmlSymbols} from "../atUtils"

export default class LockTableTooltipController{
    constructor(userMap, tooltipDivId, weekDayNames){
        this.userMap = userMap;
        this.title = new DhtmlTitle( tooltipDivId, true, true );
        this.dateFormat = new DateFormat("MMM dd");
        this.dateFormat = new DateFormat("MMM dd, yyyy");
        this.tooltipsEnabled = true;
        this.hiddenTooltip = null;
        this.weekDayNames = weekDayNames;
    }

    enableTooltips(enabled)
    {
        this.tooltipsEnabled = enabled;
        if (!enabled)
        {
            this.title.immediateHide();
        }
        else if (this.hiddenTooltip)
        {
            this.showTooltip(this.hiddenTooltip.getTooltip, this.hiddenTooltip.x, this.hiddenTooltip.y);
            this.hiddenTooltip = null;
        }
    }

    correctY(y, evt)
    {
        var height = getObjectHeight(this.title.getDiv().id);
        var horizontalScrollHeight = 16;
        var oversizeY = y + height - getBodyScrollTop() - getInsideWindowHeight() + horizontalScrollHeight;
        if (oversizeY > 0)
            y = evt.clientY + getBodyScrollTop() - 2 - height;
        return y;
    }

    addTooltip(element, getTooltip)
    {
        var dx = 12;
        var dy = 14;
        var self = this;
        element.hasCustomTooltip = true;

        var prevOnmouseover = element.onmouseover;
        element.onmouseover = function(evt)
        {
            if (prevOnmouseover)
                prevOnmouseover.call(this, evt);

            evt = getEventObj(evt);
            var x = evt.clientX + getBodyScrollLeft() + dx;
            var y = evt.clientY + getBodyScrollTop() + dy;

            y = self.correctY(y, evt);

            self.showTooltip(getTooltip, x, y);
        };

        var prevOnmousemove = element.onmousemove;
        element.onmousemove = function(evt)
        {
            if (prevOnmousemove)
                prevOnmousemove.call(this, evt);

            evt = getEventObj(evt);
            var x = evt.clientX + getBodyScrollLeft() + dx;
            var y = evt.clientY + getBodyScrollTop() + dy;

            y = self.correctY(y, evt);

            self.moveTooltip(x, y);
        };

        var prevOnmouseout = element.onmouseout;
        element.onmouseout = function(evt)
        {
            if (prevOnmouseout)
                prevOnmouseout.call(this, evt);

            var hideTooltip = true;
            var target = getTargetElement(getEventObj(evt));
            while (target)
            {
                if (target.hasCustomTooltip)
                {
                    hideTooltip = false;
                    break;
                }
                else
                {
                    target = target.parentElement;
                }
            }

            if (hideTooltip)
                self.hideTooltip();
        };
    }

    addDayTooltip(td, userId, date, leaveInfo, overtimeInfo, userDayInfo)
    {
        var self = this;
        this.addTooltip(td, function() { return self.getDayTooltipText(userId, date, leaveInfo, overtimeInfo, userDayInfo); });
    }

    addTaskTooltip(element, taskBean)
    {
        var self = this;
        this.addTooltip(element, function() { return self.getTaskTooltipText(taskBean); });
    }

    addTaskDayTooltip(element, userId, date, taskBean, userDayInfo)
    {
        var self = this;
        this.addTooltip(element, function() { return self.getTaskDayTooltipText(userId, date, taskBean, userDayInfo) });
    }

    addNotAvailableTasksTooltip(element, taskBean)
    {
        var self = this;
        this.addTooltip(element, function() { return self.getNotAvailableTasksTooltipText(taskBean) });
    }

    addLeaveTooltip(element, userId, date, leaveInfo, userDayInfo)
    {
        var self = this;
        this.addTooltip(element, function() { return self.getLeaveDayTooltipText(userId, date, leaveInfo, userDayInfo) });
    }

    getTaskTooltipText(taskBean)
    {
        return this.getCPTNamesInTextArray(taskBean, "", "taskName", "customerProject", true, false).join("");
    }

    getDayTooltipText(userId, date, leaveInfo, overtimeInfo, userDayInfo)
    {
        var result = this.getUserNameAndDateInTextArray(userId, date);

        var showLeaveInfo = false;
        var showSeparator = false;
        if (typeof leaveInfo != typeof undefined && leaveInfo.time > 0)
        {
            result = result.concat(this.getLeaveInfoInTextArray(leaveInfo));
            showLeaveInfo = true;
        }
        //alert(overtime)
        if (overtimeInfo.time != 0 || overtimeInfo.showOvertimeWhenZero)
        {
            result = result.concat(this.getOvertimeInTextArray(overtimeInfo, showLeaveInfo));
            showSeparator = true;
        }

        showSeparator = showLeaveInfo || showSeparator;
        result = result.concat(this.getDayInfoInTextArray(userDayInfo, showSeparator));
        return result.join("");
    }

    getTaskDayTooltipText(userId, date, taskBean, userDayInfo)
    {
        var result = this.getUserNameAndDateInTextArray(userId, date);

        result = result.concat(this.getCPTNamesInTextArray(taskBean, "timeTooltipTaskNameWithStatus ellipsis", "timeTooltipTaskName", "timeTooltipCustomerProjectNames ellipsis", false, true));

        result = result.concat(this.getDayInfoInTextArray(userDayInfo, true));
        return result.join("");
    }

    getNotAvailableTasksTooltipText(taskBean)
    {
        var result = this.getCPTNamesInTextArray(taskBean, "", "taskName", "customerProject", true, false).join("");
        result = result.concat(createDiv("separator", messageResource.getEscapedMessage("common.tooltip.not_assigned_task")));
        return createDiv("notAvailableTasksTooltipText", result);
    }

    getLeaveDayTooltipText(userId, date, leaveInfo, userDayInfo)
    {
        var result = this.getUserNameAndDateInTextArray(userId, date);

        if (typeof leaveInfo != typeof undefined && leaveInfo.time > 0)
        {
            result = result.concat(this.getLeaveInfoInTextArray(leaveInfo, true));
        }
        result = result.concat(this.getDayInfoInTextArray(userDayInfo, true));
        return result.join("");
    }

    getUserNameAndDateInTextArray(userId, date)
    {
        return ['<span class="userNameAndDate">', this.getFullName(userId),
                " / <span class='cellDate'>", this.weekDayNames[date.getDay()], ", ", this.dateFormat.formatDate(date), "</span></span>"];
    }

    getCPTNamesInTextArray(taskBean, taskNameWithStatusClass, taskNameClass, CPNamesClass, useBR, shouldTruncate)
    {
        return ['<span class="', taskNameWithStatusClass, '">',
                '<span class="', taskNameClass, '">',
                shouldTruncate ? this.truncateString(taskBean.name, 60 - (taskBean.completed ? messageResource.getMessage('common.completed').length : 0)) :
                taskBean.name,
                '</span>',
                (taskBean.completed ? ' <span class="completed">(' + messageResource.getMessage('common.completed') + ')</span>' : ''),
                '</span>',
                useBR ? '<br/>' : '',
                '<span class="', CPNamesClass, '">',
                shouldTruncate ? this.truncateString(taskBean.customerName, 35) :
                taskBean.customerName,
                ' / ',
                shouldTruncate ? this.truncateString(taskBean.projectName, 35) :
                taskBean.projectName,
                '</span>'
        ]
    }

    getDayInfoInTextArray(userDayInfo, showSeparator)
    {
        showSeparator = showSeparator && (userDayInfo.locked || (userDayInfo.approveInfo && (userDayInfo.approveInfo.approved || userDayInfo.approveInfo.autoApproved)));
        var self = this;
        var result = [];
        result.push('<div class="infoDayDiv', showSeparator ? ' daySeparator' : '', '">');
        if (userDayInfo.approveInfo)
        {
            result.push(this.getApproveInfoInTextArray(userDayInfo.approveInfo));

        }
        if (userDayInfo.locked)
        {
            result.push(self.getLockedInfoInTextArray(userDayInfo));
        }
        result.push('</div>');
        return result;
    }

    getLockedInfoInTextArray(userDayInfo)
    {
        var result = [];
        result.push('<div class="lockInfoDiv tooltipText">');
        result.push(messageResource.getMessage("lock_tt.table.tooltip.locked"));
        var name = this.getFullName(userDayInfo.whoLocked);
        var lockDate = this.dateFormat.formatDate(userDayInfo.lockDate);
        if (name)
        {
            result.push(messageResource.getMessage("lock_tt.table.tooltip.by", [name]));
        } // if the user is unknown, just skipping the "by" part
        result.push(messageResource.getMessage("lock_tt.table.tooltip.on", [lockDate]));
        result.push('</div>');
        return result.join("");
    }

    getApproveInfoInTextArray(approveInfo, showSeparator)
    {
        var result = [];
        if (approveInfo.autoApproved || approveInfo.approved)
        {
            result.push('<div class="approveInfoDiv tooltipText">');
            result.push(messageResource.getMessage("lock_tt.table.tooltip.approved"));
            if (approveInfo.autoApproved && approveInfo.whoApproved == null)
            {
                result.push(" ");
                result.push(messageResource.getMessage("lock_tt.table.tooltip.approved.automatically"));
            }
            else
            {
                var name;
                if (approveInfo.whoApproved != null)
                    name = this.getFullName(approveInfo.whoApproved);
                else
                    name = messageResource.getMessage("lock_tt.table.tooltip.approved.system");
                var approvedDate = this.dateFormat.formatDate(approveInfo.approvedDate);
                result.push(messageResource.getMessage("lock_tt.table.tooltip.by", [name]));
                result.push(messageResource.getMessage("lock_tt.table.tooltip.on", [approvedDate]));
            }
            result.push('</div>');
        }
        return result.join("");
    }


    getLeaveInfoInTextArray(leaveInfo, showWithoutTime)
    {
        var result = [];

        result.push("<div class='leaveInfo' style='background-image: url(", '"', leaveInfo.leaveInfo.iconPath, '"', ")'>",
            this.truncateString(leaveInfo.leaveInfo.name, 35));
        if (!showWithoutTime)
            result.push("&nbsp;&nbsp;<span class='time'>", UserTime.formatTime(leaveInfo.time), "</span>");
        result.push("</div>");
        return result;
    }

    getOvertimeInTextArray(overtimeInfo, shouldShift)
    {
        var result = [];

        result.push("<div class='overtimeInfo", shouldShift ? "Shifted" : "", "'>");
        if (overtimeInfo.showTime)
        {
            result.push(messageResource.getMessage("overtime.overtime") );
            result.push("&nbsp;&nbsp;<span class='time'>", UserTime.formatTime(overtimeInfo.time), "</span>");
        }
        else
            result.push(overtimeInfo.overtimeText);
        result.push("</div>");
        return result;
    }

    getFullName(userId)
    {
        var user = this.userMap[userId];
        if (user)
        {
            return escapeHtmlSymbols(user.formatNameFML());
        }
        else
        {
            return null;
        }
    }

    showTooltip(getTooltip, x, y)
    {
        if (this.tooltipsEnabled)
        {
            this.title.show(getTooltip(), null, x, y);
        }
        else
        {
            this.hiddenTooltip = {getTooltip: getTooltip, x: x, y: y};
        }
    }

    moveTooltip(x, y)
    {
        if (this.tooltipsEnabled)
        {
            this.title.shiftTo(x, y);
        }
        else if (this.hiddenTooltip)
        {
            this.hiddenTooltip.x = x;
            this.hiddenTooltip.y = y;
        }
    }

    hideTooltip()
    {
        if (this.tooltipsEnabled)
        {
            this.title.immediateHide();
        }
        else
        {
            this.hiddenTooltip = null;
        }
    }

    truncateString(stringToTruncate, maxLength)
    {
        var length = maxLength - 3;
        return stringToTruncate.length <= maxLength ? stringToTruncate : stringToTruncate.substr(0, length) + "...";
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/LockTableTooltipController.js